import React, { useState, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";

type Inputs = {
  email: string;
  password: string;
};

function ForgetPassword() {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();
  const [isDisableButton, setIsDisableButton] = useState(true);
  const [emailUser, setEmailUser] = useState("");
  const onSubmit: SubmitHandler<Inputs> = (data) => console.log(data);

  const handleCheckEmail = (email: string) => {
    let regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (regex.test(email)) {
      setIsDisableButton(false);
    }
  };

  useEffect(() => {
    const subscription = watch((value) => {
      if (typeof value.email === "string") {
        setEmailUser(value.email);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    handleCheckEmail(emailUser);
  }, [emailUser]);

  return (
    <div className="bg-background-app grid grid-cols-12 w-screen h-screen font-noto-sans-thai">
      <div className="col-span-10 md:col-span-6 col-start-2 md:col-start-4 self-center">
        <div className="w-full max-w-[420px] h-auto mx-auto flex flex-col gap-4 p-6 bg-background-paper rounded-3xl border-[1px] border-gray-1 shadow-z12 items-center">
          <img
            alt="logo-bar"
            src="images/logo-bar.svg"
            className="w-[198px] h-[72px]"
          />
          <p className="text-xl font-medium text-text-primary">ลืมรหัสผ่าน</p>
          <p className="text-sm text-text-primary text-center">
            กรุณากรอกอีเมลของคุณเพื่อรีเซ็ตรหัสผ่าน
          </p>
          <form
            className="flex flex-col gap-4 w-full"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="flex flex-col gap-2 w-full ">
              <label className="text-sm text-text-primary" htmlFor="email">
                อีเมล
              </label>
              <input
                id="email"
                placeholder="อีเมล"
                className={`w-full h-10 focus:!outline-none text-sm placeholder:text-text-disabled px-4 py-1 self-stretch rounded-xl border-[1px] ${
                  errors.email ? "border-error-main" : "border-gray-1"
                }`}
                {...register("email", {
                  required: "กรุณากรอกอีเมล",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "กรุณากรอกอีเมลให้ถูกต้อง",
                  },
                })}
              />
              {errors.email && (
                <span className="text-xs text-error-main font-light leading-[18px]">
                  {errors.email.message}
                </span>
              )}
            </div>

            <button
              type="submit"
              disabled={isDisableButton}
              className="w-full bg-primary-main disabled:bg-gray-1 disabled:text-text-disabled hover:bg-opacity-70 px-10 py-2 text-sm text-primary-contrast leading-[22px] rounded-xl"
            >
              ยืนยัน
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

function ForgetPasswordSentEmail() {
  return (
    <div className="bg-background-app grid grid-cols-12 w-screen h-screen font-noto-sans-thai">
      <div className="col-span-6 col-start-4 self-center">
        <div className="w-full max-w-[420px] h-auto mx-auto flex flex-col gap-4 p-6 bg-background-paper rounded-3xl border-[1px] border-gray-1 shadow-z12 items-center">
          <img
            alt="logo-bar"
            src="images/logo-bar.svg"
            className="w-[198px] h-[72px]"
          />
          <p className="text-xl font-medium text-text-primary">
            ใกล้จะสำเร็จแล้ว
          </p>
          <p className="text-sm text-text-primary text-center">
            Check your email{" "}
            <span className="text-primary-main">ibitz-company@gmail.com</span>,
            We have sent you the verify email already. Please click link to
            verify identity before login
          </p>
          <div className="w-full h-[1px] bg-gray-2" />
          <button className="text-primary-main text-sm underline">
            ส่งอีเมลอีกครั้ง
          </button>
          <button className="text-primary-main text-sm underline">
            พิมพ์อีเมลอีกครั้ง
          </button>
          <button className="text-primary-main text-sm underline">
            ติดต่อเจ้าหน้าที่
          </button>
          <div className="flex gap-1 pt-6">
            <p className="text-text-secondary text-sm ">กลับไปยังหน้า</p>
            <p className="text-primary-main text-sm font-medium">เข้าสู่ระบบ</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ForgetPassword, ForgetPasswordSentEmail };
